(function () {
  'use strict';

  var MRW_HEADER_SELECTOR = '[id^="mrw-div-embedded-wishlist-header-container"]';
  var MRW_WISHLIST_CLICK_SELECTOR =
    'mrw-wishlist-button, mrw-wishlist-card-button, mrw-wishlist-product-card, .mrw-wishlist-product-card';
  var MRW_WISHLIST_PAGE_DELETE_SELECTOR =
    '.mrw-product-card__delete, [class*="mrw-product-card__delete"]';
  var MRW_CACHE_DB = 'MrwCache';
  var MRW_CACHE_STORE = 'cache';
  var MRW_COUNT_STORAGE_KEY = 'mrw_header_wishlist_count';
  var lastRenderedCount = null;
  var lastKnownCount = 0;
  var syncTimer = null;
  var headerObserver = null;
  var observedContainers = new WeakSet();
  var removalSyncActive = false;
  var removalSyncTimer = null;

  function sanitizeCount(count) {
    var value = Number(count);
    if (!isFinite(value) || value <= 0) return 0;
    return Math.floor(value);
  }

  function parseWishlistCount(wishlist) {
    if (!wishlist || typeof wishlist !== 'object') return 0;

    if (Array.isArray(wishlist.items)) {
      return sanitizeCount(wishlist.items.length);
    }

    return sanitizeCount(wishlist.itemCount);
  }

  function parseWishlistEntry(entryValue) {
    if (!entryValue || !entryValue.data || typeof entryValue.data !== 'object') {
      return 0;
    }

    if (entryValue.data.wishlist) {
      return parseWishlistCount(entryValue.data.wishlist);
    }

    if (Array.isArray(entryValue.data.items) || entryValue.data.itemCount != null) {
      return parseWishlistCount(entryValue.data);
    }

    return 0;
  }

  function parseCountFromCacheRow(row) {
    if (!row || typeof row !== 'object') return null;

    for (var key in row) {
      if (!Object.prototype.hasOwnProperty.call(row, key)) continue;
      if (key.indexOf('api/wishlist?') !== 0) continue;
      return sanitizeCount(parseWishlistEntry(row[key]));
    }

    return null;
  }

  function saveCountToStorage(count) {
    try {
      sessionStorage.setItem(MRW_COUNT_STORAGE_KEY, String(sanitizeCount(count)));
    } catch (error) {
      /* noop */
    }
  }

  function readCountFromStorage() {
    try {
      return sanitizeCount(sessionStorage.getItem(MRW_COUNT_STORAGE_KEY));
    } catch (error) {
      return 0;
    }
  }

  function renderWishlistCountBubble(container, count) {
    var safeCount = sanitizeCount(count);
    var bubble = container.querySelector('.mrw-wishlist-count-bubble');

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble mrw-wishlist-count-bubble';
      bubble.setAttribute('aria-live', 'polite');
      container.appendChild(bubble);
    }

    if (safeCount <= 0) {
      bubble.innerHTML = '';
      bubble.style.display = 'none';
      return false;
    }

    var label = safeCount < 100 ? String(safeCount) : '99+';
    bubble.style.display = '';
    bubble.innerHTML =
      '<span aria-hidden="true">' + label + '</span>' +
      '<span class="visually-hidden">' + safeCount + ' wishlist items</span>';
    return true;
  }

  function getHeaderContainers() {
    return document.querySelectorAll(MRW_HEADER_SELECTOR);
  }

  function bubbleIsMissing(count) {
    var containers = getHeaderContainers();
    if (!containers.length) return true;
    if (sanitizeCount(count) <= 0) return false;

    for (var i = 0; i < containers.length; i++) {
      var bubble = containers[i].querySelector('.mrw-wishlist-count-bubble');
      if (!bubble || bubble.style.display === 'none' || !bubble.textContent.trim()) {
        return true;
      }
    }

    return false;
  }

  function renderAllHeaderCounts(count, force) {
    var safeCount = sanitizeCount(count);
    var containers = getHeaderContainers();

    lastKnownCount = safeCount;

    if (!containers.length) {
      return false;
    }

    if (!force && safeCount === lastRenderedCount && !bubbleIsMissing(safeCount)) {
      return true;
    }

    var rendered = false;

    containers.forEach(function (container) {
      if (renderWishlistCountBubble(container, safeCount)) {
        rendered = true;
      }
    });

    lastRenderedCount = safeCount;
    saveCountToStorage(safeCount);

    return rendered || safeCount === 0;
  }

  function observeHeaderContainer(container) {
    if (observedContainers.has(container)) return;
    observedContainers.add(container);

    new MutationObserver(function () {
      scheduleSync(true);
    }).observe(container, {
      childList: true,
      subtree: true
    });
  }

  function observeAllHeaderContainers() {
    getHeaderContainers().forEach(observeHeaderContainer);
  }

  function readMrwWishlistCountFromDb() {
    return new Promise(function (resolve) {
      if (!window.indexedDB) {
        resolve(readCountFromStorage());
        return;
      }

      var request = indexedDB.open(MRW_CACHE_DB);

      request.onerror = function () {
        resolve(readCountFromStorage());
      };

      request.onsuccess = function (event) {
        var db = event.target.result;

        if (!db.objectStoreNames.contains(MRW_CACHE_STORE)) {
          resolve(readCountFromStorage());
          return;
        }

        var tx = db.transaction(MRW_CACHE_STORE, 'readonly');
        var storeRequest = tx.objectStore(MRW_CACHE_STORE).getAll();

        storeRequest.onerror = function () {
          resolve(readCountFromStorage());
        };

        storeRequest.onsuccess = function (storeEvent) {
          var entries = storeEvent.target.result || [];

          for (var i = 0; i < entries.length; i++) {
            var count = parseCountFromCacheRow(entries[i]);
            if (count !== null) {
              resolve(count);
              return;
            }
          }

          resolve(readCountFromStorage());
        };
      };
    });
  }

  function syncFromCache(force) {
    return readMrwWishlistCountFromDb().then(function (count) {
      if (removalSyncActive && sanitizeCount(count) > lastKnownCount) {
        count = lastKnownCount;
      }

      renderAllHeaderCounts(count, force);
      return count;
    });
  }

  function beginRemovalSync() {
    removalSyncActive = true;

    if (removalSyncTimer) window.clearTimeout(removalSyncTimer);

    removalSyncTimer = window.setTimeout(function () {
      removalSyncActive = false;
      removalSyncTimer = null;
    }, 5000);
  }

  function scheduleSync(force) {
    if (syncTimer) window.clearTimeout(syncTimer);

    syncTimer = window.setTimeout(function () {
      observeAllHeaderContainers();
      syncFromCache(force);
    }, force ? 0 : 16);
  }

  function syncSoon() {
    observeAllHeaderContainers();

    if (!removalSyncActive) {
      syncFromCache(true);
    }

    [50, 150, 300, 600, 1200, 2500].forEach(function (delay) {
      window.setTimeout(function () {
        observeAllHeaderContainers();
        syncFromCache(true);
      }, delay);
    });
  }

  function patchFetchForLiveUpdates() {
    if (window.__mrwWishlistCountFetchPatch || !window.fetch) return;
    window.__mrwWishlistCountFetchPatch = true;

    var originalFetch = window.fetch;

    window.fetch = function patchedFetch(input) {
      var responsePromise = originalFetch.apply(this, arguments);
      var url = typeof input === 'string' ? input : input && input.url;

      if (url && /wishlist|monkwishlist/i.test(url)) {
        responsePromise.then(function () {
          syncSoon();
        }).catch(function () {
          /* noop */
        });
      }

      return responsePromise;
    };
  }

  function patchIndexedDbForLiveUpdates() {
    if (window.__mrwWishlistCountIdbPatch) return;
    window.__mrwWishlistCountIdbPatch = true;

    var originalPut = IDBObjectStore.prototype.put;

    IDBObjectStore.prototype.put = function patchedPut(value) {
      var request = originalPut.apply(this, arguments);

      try {
        var transaction = this.transaction;
        var dbName = transaction && transaction.db && transaction.db.name;

        if (dbName === MRW_CACHE_DB && value && typeof value === 'object') {
          var count = parseCountFromCacheRow(value);
          if (count !== null) {
            window.requestAnimationFrame(function () {
              observeAllHeaderContainers();
              renderAllHeaderCounts(count, true);
              saveCountToStorage(count);
            });
          }
        }
      } catch (error) {
        /* noop */
      }

      return request;
    };

    function patchIdbStoreMethod(methodName) {
      var original = IDBObjectStore.prototype[methodName];
      if (!original) return;

      IDBObjectStore.prototype[methodName] = function patchedStoreMethod() {
        var request = original.apply(this, arguments);

        try {
          var transaction = this.transaction;
          var dbName = transaction && transaction.db && transaction.db.name;

          if (dbName === MRW_CACHE_DB) {
            request.addEventListener('success', function () {
              scheduleSync(true);
            });
          }
        } catch (error) {
          /* noop */
        }

        return request;
      };
    }

    patchIdbStoreMethod('delete');
    patchIdbStoreMethod('clear');
  }

  function watchHeaderContainers() {
    if (headerObserver) return;

    headerObserver = new MutationObserver(function () {
      if (getHeaderContainers().length) {
        observeAllHeaderContainers();
        scheduleSync(true);
      }
    });

    headerObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function syncAfterWishlistRemoval() {
    beginRemovalSync();
    observeAllHeaderContainers();

    [150, 400, 900, 1800, 3000].forEach(function (delay) {
      window.setTimeout(function () {
        observeAllHeaderContainers();
        syncFromCache(true);
      }, delay);
    });
  }

  function bindWishlistInteractions() {
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!(target instanceof Element)) return;

        if (target.closest(MRW_WISHLIST_PAGE_DELETE_SELECTOR)) {
          var optimisticCount = Math.max(0, lastKnownCount - 1);
          observeAllHeaderContainers();
          renderAllHeaderCounts(optimisticCount, true);
          syncAfterWishlistRemoval();
          return;
        }

        if (target.closest(MRW_WISHLIST_CLICK_SELECTOR)) {
          syncSoon();
        }
      },
      true
    );

    window.addEventListener('mrw:wishlist-count', function (event) {
      if (event.detail && event.detail.count != null) {
        observeAllHeaderContainers();
        renderAllHeaderCounts(event.detail.count, true);
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) syncSoon();
    });
  }

  function bootstrap() {
    patchIndexedDbForLiveUpdates();
    patchFetchForLiveUpdates();
    watchHeaderContainers();
    bindWishlistInteractions();

    var cachedCount = readCountFromStorage();
    if (cachedCount > 0) {
      renderAllHeaderCounts(cachedCount, true);
    }

    syncSoon();

    var attempts = 0;
    var bootstrapTimer = window.setInterval(function () {
      attempts += 1;
      observeAllHeaderContainers();
      syncFromCache(true);

      var containers = getHeaderContainers();
      var count = lastKnownCount;
      var isReady =
        containers.length > 0 &&
        (count <= 0 || !bubbleIsMissing(count));

      if (isReady || attempts >= 40) {
        window.clearInterval(bootstrapTimer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  window.addEventListener('pageshow', function () {
    syncSoon();
  });

  window.addEventListener('load', function () {
    syncSoon();
  });
})();
